export const URL_GOOGLE_RECAPTCHA = 'https://www.google.com/recaptcha/api.js?render=';
